import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { useTooltip } from './TooltipContext.js';
import { TooltipTriggerIcon } from './TooltipTriggerIcon.js';

const TooltipTrigger = /*#__PURE__*/ React.forwardRef(({ 'aria-label': ariaLabel , label , renderLabel , iconName , theme , preventClickDefault , onClick  }, ref)=>{
    const { isActive: isActive1 , setIsActive , isTouch  } = useTooltip();
    const { getLabel  } = useIntl();
    const triggerRef = React.useRef(null);
    const computedAriaLabel = (label === null || label === void 0 ? void 0 : label.trim()) || ariaLabel || getLabel('common.tooltip');
    // Only add `aria-label` if `renderLabel` is false (non banner tooltips) and `computedAriaLabel` exists
    const ariaLabelProps = !renderLabel && computedAriaLabel ? {
        'aria-label': computedAriaLabel
    } : {};
    // Touch device handlers
    const handleDocumentClick = React.useCallback((e)=>{
        // Check if the clicked target is not equal to our trigger, preventing the tooltip to re-open immediately
        setIsActive((isActive)=>{
            if (isActive && triggerRef.current && !triggerRef.current.contains(e.target)) {
                return false;
            }
            return isActive;
        });
    }, [
        setIsActive
    ]);
    React.useEffect(()=>{
        if (!isTouch) {
            return;
        }
        document.addEventListener('touchend', handleDocumentClick);
        return ()=>document.removeEventListener('touchend', handleDocumentClick)
        ;
    }, [
        isTouch,
        handleDocumentClick
    ]);
    const handleTriggerClick = React.useCallback((e)=>{
        preventClickDefault && e.preventDefault();
        isTouch && setIsActive((isActive)=>!isActive
        );
        onClick && onClick();
    }, [
        isTouch,
        setIsActive,
        preventClickDefault,
        onClick
    ]);
    // Non-touch handlers
    const handleTriggerMouseOver = React.useCallback(()=>{
        !isTouch && setIsActive(true);
    }, [
        isTouch,
        setIsActive
    ]);
    const handleTriggerMouseLeave = React.useCallback(()=>{
        // this timeout allows a user to move it's cursor from the trigger to the tooltip to keep the tooltip open
        !isTouch && setTimeout(()=>setIsActive(false)
        , 100);
    }, [
        isTouch,
        setIsActive
    ]);
    const handleKeyPress = (e)=>{
        if (e.key === 'Enter') {
            !isTouch && setIsActive(true);
            if (!isTouch && isActive1) {
                setIsActive(false);
            }
        }
        if (e.key === 'Escape') {
            setIsActive(false);
        }
    };
    const buttonClass = classnames('tooltip__button', {
        'tooltip__button--active': isActive1
    });
    const showTooltipAsFilled = Boolean(isActive1 || theme);
    return /*#__PURE__*/ React.createElement("div", {
        ref: triggerRef
    }, /*#__PURE__*/ React.createElement("button", swcHelpers.extends({
        type: "button"
    }, ariaLabelProps, {
        "aria-expanded": isActive1,
        className: buttonClass,
        ref: ref,
        onClick: handleTriggerClick,
        onMouseOver: handleTriggerMouseOver,
        onMouseLeave: handleTriggerMouseLeave,
        onFocus: ()=>null
        ,
        onKeyUp: handleKeyPress
    }), /*#__PURE__*/ React.createElement(TooltipTriggerIcon, {
        name: iconName,
        isHidden: showTooltipAsFilled
    }), /*#__PURE__*/ React.createElement(TooltipTriggerIcon, {
        name: `${iconName}-filled`,
        isHidden: !showTooltipAsFilled
    }), renderLabel && label));
});

export { TooltipTrigger };
//# sourceMappingURL=TooltipTrigger.js.map
